import { render, staticRenderFns } from "./system_note.vue?vue&type=template&id=0c1b95c7"
import script from "./system_note.vue?vue&type=script&lang=js"
export * from "./system_note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports